import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  // Le chiamate PVGIS devono uscire "pulite" da header applicativi.
  if (req.url.startsWith('/pvgis')) {
    return next(req);
  }

  // se l’URL comincia con uno dei domini esclusi -> bypass
  const isExcluded = environment.excludedDomains.some((domain) =>
    req.url.startsWith(domain),
  );

  if (isExcluded) {
    return next(req);
  }

  const translate = inject(TranslateService);

  const lang = translate.getCurrentLang() ?? translate.getFallbackLang();

  // altrimenti aggiungo l’header
  return next(
    req.clone({
      headers: req.headers.append('x-hasura-lang', lang),
    }),
  );
};
